module.exports = __webpack_public_path__ + "img/banner.431cbe3f.jpg";